module.exports = __webpack_public_path__ + "static/media/sell-used-trucks-underwood.cdc23008.png";